import React from 'react';
import PropTypes from 'prop-types';
import {ValueComparer} from './value-comparer';

const valueComparer = new ValueComparer();

export const AvailStringField = ({assignedKey, value, oldValue}) => (
  <p>
    <strong>{`${assignedKey}:`}&nbsp;</strong>
    <StringComparingComponent current={value} previous={oldValue} />
  </p>
);
// es
AvailStringField.propTypes = {
  assignedKey: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  oldValue: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
};
export const StringComparingComponent = ({current, previous}) => {
  const valueStatus = valueComparer.compareValues(previous, current);

  return (
    <>
      {valueStatus !== valueComparer.VALUE_UNCHANGED && valueStatus !== valueComparer.VALUE_CREATED && (
        <>
          <span style={{color: valueStatus !== valueComparer.VALUE_DELETED ? 'green' : 'red'}}>
            <b>{valueStatus}</b>
          </span>
          <br />
          {valueComparer.VALUE_CREATED !== valueStatus && (
            <>
              <strike style={{color: 'darkred'}}>
                {typeof previous === 'boolean' ? `${previous.toString()}` : previous}
              </strike>
              <br />
            </>
          )}
        </>
      )}
      <span>
        {valueStatus !== valueComparer.VALUE_DELETED && typeof current === 'boolean' ? current.toString() : current}
      </span>
    </>
  );
};

StringComparingComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  current: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  previous: PropTypes.any,
};

export const AvailExtendedStringField = ({assignedKey, value, oldValue}) => (
  <>
    <p>
      <strong>{assignedKey}:</strong>
    </p>
    <ul>
      {Object.keys(value).map(key => (
        <li key={key}>
          <AvailStringField assignedKey={key} oldValue={oldValue?.[key]} value={value[key]} />
        </li>
      ))}
    </ul>
  </>
);

AvailExtendedStringField.propTypes = {
  assignedKey: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  oldValue: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
};
